<template>
    <div class="code-with-copy">
        <pre><code :class="codeClass" :key="uniqueKey">{{ code }}</code></pre>
        <button class="btn-copy" @click="copy" :title="title">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        code: {
            type: String,
            required: true
        },
        lang: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: 'Copy'
        },
        message: {
            type: String,
            default: 'Copied to clipboard'
        }
    },
    computed: {
        codeClass() {
            return this.lang ? `highlight ${this.lang}` : 'highlight'
        },
        uniqueKey() {
            // Use full code for key to force re-render when any part changes
            return `code-${this.code}`
        }
    },
    methods: {
        copy() {
            this.$methods.copyToClipboard(this.code)
            this.$notify.success({
                title: 'Copied',
                message: this.message
            })
        }
    }
}
</script>

<style>
.code-with-copy {
    position: relative;
    display: inline-block;
    background: rgb(40, 44, 52);
    border-radius: 6px;
}

.code-with-copy pre {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
}

.code-with-copy code {
    display: block !important;
    padding: 13px 45px 13px 13px !important;
    background: transparent !important;
}

.code-with-copy .btn-copy {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(255, 255, 255, 0.08);
    border: none;
    color: #8b949e;
    padding: 5px 7px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s;
    line-height: 1;
    z-index: 10;
}

.code-with-copy .btn-copy:hover {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
}
</style>
